import { LOADING_IMAGE } from "../../common/constants";
import ImageHelper from "../image-helper";
export default class ImageLoader {
  update(el, binding) {
    //if (binding.value != binding.oldValue) {
      ImageLoader.loadImage(el, binding);
    //}
  }

  bind(el, binding) {
    // Paint the placeholder before resolving, like ImageLazyLoader — loadImage
    // overwrites it synchronously for ready publish urls, or async otherwise
    el.src = LOADING_IMAGE;
    el.style.objectFit = "scale-down";
    ImageLoader.loadImage(el, binding);
  }

  static loadImage(el, binding) {
    ImageHelper.populateImageUrl(el, binding.value, true);
  }
}
